module.exports = __webpack_public_path__ + "assets/img/36_1504_big.22df80ab.jpg";